import React, { useState } from "react";

const ContactPage = () => {
  const [status, setStatus] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const data = new FormData(form);
    const name = data.get("name") || "";
    const email = data.get("email") || "";
    const message = data.get("message") || "";

    const subject = encodeURIComponent("New message from Hacky Apps site");
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
    );

    window.location.href = `mailto:info@hackyapps.com?subject=${subject}&body=${body}`;
    setStatus(
      "Your email app should open now with the message filled in. If it did not, email info@hackyapps.com directly."
    );
  };

  return (
    <div className="contact-main">
      <h1 className="section-title">Say Hello</h1>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" required />
          </label>
          <label>
            Email
            <input type="email" name="email" required />
          </label>
          <label>
            Message
            <textarea name="message" rows="5" required />
          </label>
          <button type="submit" className="cta-btn">
            Send it!
          </button>
          {status && <p>{status}</p>}
        </form>
        <div className="contact-info">
          <h2>We’d love to hear from you.</h2>
          <p>
            Drop us a note and we’ll get back to you soon.
            <br />
            Or just email:{" "}
            <a href="mailto:info@hackyapps.com">info@hackyapps.com</a>
          </p>
          <p>NYC-based, working everywhere.</p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
